'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

var network = {
  equeue: function equeue(method, url, data, callback) {
    (0, _axios2.default)({
      withCredentials: false,
      method: method,
      url: url,
      data: _qs2.default.stringify(data)
    }).then(function (response) {
      if (response.status === 200) {
        if (callback) {
          callback(null, response.data);
        }
      } else {
        if (callback) {
          callback({ code: -1, msg: '请求错误' }, null);
        }
      }
    }).catch(function (err) {
      if (callback) {
        callback({ code: -1, msg: '网络请求失败' }, '');
      }
    });
  },
  get: function get(url, data, callback) {
    url = url + '?';
    Object.keys(data).map(function (key) {
      url = url + '&' + key + '=' + data[key];
    });
    this.equeue('get', url, data, callback);
  },
  post: function post(url, data, callback) {
    this.equeue('post', url, data, callback);
  }
};

exports.default = network;
//# sourceMappingURL=network.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ciim_sdk@3.0.8@ciim_sdk/dist/im/network.js
// module id = 91BL
// module chunks = 0